export const SettingsRoutePath = {
  ROOT: '/settings',
  CHECK_PASSWORD: '/settings/check-password',
  ACCOUNT: '/settings/account',
  CREDENTIALS: '/settings/credentials',
  CREDENTIALS_IAM_LIST: '/settings/credentials/iam',
} as const;
